import React, { useState } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import Button from "@mui/material/Button";
import { useForm, Controller } from "react-hook-form";
import { z } from "utils/zod-pt";
import { zodResolver } from "@hookform/resolvers/zod";
import { ThemeProvider, useTheme } from "@mui/material/styles";
import { customTheme } from "styles/CustomField";
import CustomLabel from "components/Label";
import * as palette from "styles/variables";
import CheckBoxOutlinedIcon from '@mui/icons-material/CheckBoxOutlined';
import { IconButton, InputAdornment } from '@mui/material';
import { CircularProgress } from "@mui/material";
import attention from "assets/icons/attention.svg"
import { set } from "date-fns";

const style = {
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 650,
  bgcolor: palette.lightBackground,
  borderRadius: "5px",
  p: 4,
};

export default function ModalFilters({ open, handleClose, onSubmit, isLoading, active }) {

  const CustomButton = ({ text, color, hoverColor, onClick, type}) => (
    <Button
    type={type}
      variant="contained"
      onClick={onClick}
      sx={{
        backgroundColor: color,
        color: '#FFFFFF',
        marginRight: 3,
        textTransform: 'none',
        fontWeight: 'bold',
        fontSize: '1.1em',
        '&:hover': {
          backgroundColor: hoverColor,
        },
        minWidth: '40%',
        height: '30%'
      }}
      startIcon={isLoading && type==='submit' && <CircularProgress sx={{marginLeft: 1}} color="inherit" size="1.2rem" />}

    >
      {text}
    </Button>
  );

  const filtersSchema = z.object({
    valueFilter: z
          .boolean(),
      justification: z
        .string()
        .min(1, "A justificativa é obrigatória")
        .max(200, "A justificativa deve ter no máximo 200 caracteres"),
    });

const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(filtersSchema),
    mode: "all",
    criteriaMode: "all",
  });


  const [confirm, setConfirm] = useState(false);
  setValue('valueFilter',!active)


  const handleCancel = () => {
    setConfirm(false)
    reset()
    handleClose()
    // window.location.reload()
  }
  const outerTheme = useTheme();
  return (
    <ThemeProvider theme={customTheme(outerTheme)}>
      <div>
        <Modal
          open={open}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"

        >
          <Box sx={style}>
            {/* Cabeçalho */}
            <div
              onClick={handleCancel}
              style={{ marginLeft: "auto", cursor: "pointer" }}
            >
              <CloseIcon />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: 'column',
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                gap: 5
              }}
            >
              <img src={attention} alt="" />
              <Typography
                variant="h5"
                component="h2"
                style={{
                  textAlign: 'center',
                  color: palette.lightAzul,
                  fontFamily: "Poppins",
                }}
              >
                {confirm ?
                  "Informe a justificativa para esta ação" : `Tem certeza que deseja ${active ? "desativar" : "ativar"} este filtro?` }
              </Typography>
              {!confirm &&
              <p
                style={{
                  textAlign: 'center',
                  color: palette.darkPreto,
                  fontFamily: "Poppins",
                  width: '80%',
                  fontSize: '0.9em',
                }}
              >
                {active ? "Ao desativá-lo, ele deixará de ser aplicado e não afetará mais os resultados." : "Ao ativá-lo, ele será aplicado e poderá impactar os resultados exibidos."}
              </p>}
              <form
              style={{ marginTop: "20px", width: "100%", display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}
              onSubmit={handleSubmit(onSubmit)}
              >
              {confirm &&
              <Controller
                              name="justification"
                              control={control}
                              render={({ field }) => (
                                <TextField
                                  {...field}
                                  style={{ marginTop: "1%" }}
                                  multiline
                                  placeholder="Justifique a ação..."
                                  rows={3}
                                  error={!!errors.justification}
                                  helperText={errors.justification?.message}
                                  fullWidth
                                  margin="normal"
                                  variant="outlined"
                                />
                              )}
                            />
            }
              
              <div style={{ display: 'flex', justifyContent: 'space-between', width: '40%', marginTop: '3%' }} >
                <CustomButton
                  text= {confirm? "Cancelar" :"Não"}
                  color={palette.lightVermelho}
                  hoverColor="#E55656"
                  onClick={handleCancel}

                />
                {confirm?
                <CustomButton
                  text={active? "Desativar" : 'Ativar'}
                  color={palette.darkAzul}
                  hoverColor="#172B6C"
                  type="submit"
                />
                :
                <CustomButton
                  text="Sim"
                  color={palette.darkAzul}
                  hoverColor="#172B6C"
                  onClick={() => setConfirm(true)}
                />}
              </div>
              </form>
            </div>
          </Box>
        </Modal>
      </div>
    </ThemeProvider>
  );
}
